import React from 'react';

import Facebook from 'shared-vectors/icons/DsFacebook';
import { Icon } from 'shared-vectors';

import createStyle from 'shared-utils/src/createStyle';

import Grid from '../../../../Grid';

import style, { mainCls } from './style';

const useStyles = createStyle(style);

export default ({
  action,
  className,
  disclaimer,
}) => {
  const cls = useStyles();
  return (
    <>
      <Grid
        justify="center"
        align="center"
        className={`${cls[mainCls]} ${className} c-txt--w`}
        onClick={action}
      >
        <Icon name={Facebook} width="24px" height="24px" fill className="mr--xs" /> Continua con Facebook
      </Grid>
      {disclaimer && (
        <p className={`${cls[`${mainCls}__text`]} tp-s--s c-txt--f2`}>
          Utilizza Facebook solo se hai già attivato un account MyCasa con questo strumento
        </p>
      )}
    </>
  );
};
